module.exports = __webpack_public_path__ + "static/media/floor_nw2.cc37f6c3.png";